import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "./style.css";
import Home from "./pages/home";
import Gallery from "./pages/gallery";
import FAQ from "./pages/faq";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Gallery} exact path="/gallery" />
        <Route component={FAQ} exact path="/faq" />
        <Route component={Home} path="*" />
      </Switch>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById("app"));
